// extracted by mini-css-extract-plugin
export default {"faqQuestion":"FaqQuestion_faqQuestion__BwU-L","title":"FaqQuestion_title__rHfXB"};